import * as React from 'react';
import cn from 'classnames';

import DesktopPassenger, { Props as DesktopPassengerProps } from '../DesktopPassenger/DesktopPassenger';
import { useTheme } from '../../../../../theme';
import DoubleSeat from '../../DoubleSeat/DoubleSeat';

interface Props extends DesktopPassengerProps {
	className?: string;
	isActiveDoubleSeat?: boolean;
	hasSeatsByPassenger?: boolean;
	showDoubleSeatInfo?: boolean;
	toggleExtraSeat?: (active: boolean) => void;
}

const MobilePassenger: React.FC<Props> = ({
	className,
	isActive,
	isActiveDoubleSeat,
	isDisabled,
	hasSeatsByPassenger,
	showDoubleSeatInfo,
	onClick,
	onClearSeat,
	toggleExtraSeat,
	...props
}) => {
	const { MobilePassenger: theme } = useTheme('SeatMap');

	const onClearSeatHandler = () => {
		if (isActive) {
			onClearSeat();
		}
	};

	const toggleExtraSeatHandler = (active: boolean) => {
		if (isActive) {
			toggleExtraSeat(active);
		}
	};

	return (
		<div
			className={cn(className, theme.container, {
				[theme.active]: isActive,
				[theme.disabled]: isDisabled
			})}
			onClick={onClick}
		>
			<DesktopPassenger
				className={theme.passenger}
				showSelect={false}
				onClearSeat={onClearSeatHandler}
				isActive={isActive}
				{...props}
			/>
			{toggleExtraSeat && !isDisabled && (
				<DoubleSeat
					className={theme.doubleSeat}
					isActive={isActiveDoubleSeat}
					hasSeatsByPassenger={hasSeatsByPassenger}
					showInfo={showDoubleSeatInfo}
					toggleExtraSeat={toggleExtraSeatHandler}
				/>
			)}
		</div>
	);
};

export default MobilePassenger;
